// ==================== USE IS SUB-ACCOUNT HOOK ====================
// Sub-accounts (role SUB_CUSTOMER) get the dashboard, the WhatsApp inbox and
// profile/organization settings. Screens use this to hide the controls a
// sub-account must not use (e.g. Edit Contact in the inbox, organization Save).

import { useAuth } from '../contexts';

export const useIsSubAccount = (): boolean => {
  const { user } = useAuth();
  return user?.role === 'SUB_CUSTOMER';
};

export default useIsSubAccount;
